export default __webpack_public_path__ + "static/media/personalInfo.533d9928.svg";